import React from "react";
import { withRouter } from "../../../App";
import { connect } from "react-redux";
import { getCandidates } from "../../../store/selectors/Candidates/CandidatesList";
import { getLoggenInToken } from "../../../store/selectors/AuthSelectors";
import { dateFormat } from "../../../utils/date";

const GridTab = ({ candidates }) => {
  return (
    <>
      <div className="row">
        {candidates.map((item, index) => (
          <div className="col-xl-3 col-lg-4 col-sm-6" key={index}>
            <div className="card">
              <div className="card-body">
                <div className="card-use-box">
                  {/* <div className="crd-bx-img">
                    <img src={item?.image} className="rounded-circle" alt="" />
                    <div
                      className={`active ${
                        item?.id === "deactive" ? "deactive" : ""
                      } `}
                    ></div>
                  </div> */}
                  <div className="card__text">
                    <h4 className="mb-0">
                      {item?.title} {item?.firstName} {item?.lastName}
                    </h4>
                    <p>{item?.email}</p>
                  </div>
                  {/* <ul className="card__info">
                    <li>
                      <span className="card__info__stats">{item.posts}</span>
                      <span>posts</span>
                    </li>
                    <li>
                      <span className="card__info__stats">
                        {item.followers}
                      </span>
                      <span>followers</span>
                    </li>
                    <li>
                      <span className="card__info__stats">
                        {item.following}
                      </span>
                      <span>following</span>
                    </li>
                  </ul> */}
                  <ul className="post-pos">
                    <li>
                      <span className="card__info__stats">
                      Registration Date:{" "}
                      </span>
                      <span>{dateFormat(item?.regDate)}</span>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </>
  );
};
const mapStateToProps = (state) => {
  return {
    candidates: getCandidates(state),
    token: getLoggenInToken(state),
  };
};

export default withRouter(connect(mapStateToProps)(GridTab));
